import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ioxhost': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M616 160H548.7C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256 72 272.4 73.6 288.5 76.7 304H24C10.7 304 0 314.8 0 328 0 341.3 10.7 352 24 352H91.3C128.8 441.3 217.1 504 320 504 457 504 568 393 568 256 568 239.6 566.4 223.5 563.3 208H616C629.3 208 640 197.2 640 184 640 170.7 629.3 160 616 160zM520 256C520 366.5 430.5 456 320 456 244.3 456 178.4 414 144.5 352H424C437.3 352 448 341.2 448 328 448 314.7 437.3 304 424 304H125.8C122 288.6 120 272.6 120 256 120 145.5 209.5 56 320 56 395.7 56 461.6 98 495.5 160H216C202.7 160 192 170.8 192 184 192 197.3 202.7 208 216 208H514.2C518 223.4 520 239.4 520 256zM216 232H424C437.3 232 448 242.7 448 256 448 269.2 437.3 280 424 280H216C202.7 280 192 269.3 192 256 192 242.8 202.7 232 216 232z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ioxhost.js
// module id = fzAc
// module chunks = 144